import {MessageBaseView} from "../../MessageModel/view/MessageBaseView";

/**
 * View model for business type details.
 * Used for dropdown options and other display purposes.
 */
export class BusinessTypeSelectOptionView {
    value: number;
    label: MessageBaseView;

    constructor(data?: any) {
        this.value = data?.value ?? 0;
        this.label = data?.label ? new MessageBaseView(data.label) : new MessageBaseView();
    }
}
